import { css } from 'styled-components';

import { DESKTOP_MEDIA_QUERY, MOBILE_MEDIA_QUERY } from '~/constants';

export const hideOnDesktop = () => css`
  ${DESKTOP_MEDIA_QUERY} {
    display: none;
  }
`;

export const hideOnMobile = () => css`
  ${MOBILE_MEDIA_QUERY} {
    display: none;
  }
`;
